import React, { useEffect } from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Problem from './components/Problem/Problem';
import Solution from './components/Solution/Solution';
import Results from './components/Results/Results';
import Services from './components/Services/Services';
import WhyUs from './components/WhyUs/WhyUs';
import Flow from './components/Flow/Flow';
import FAQ from './components/FAQ/FAQ';
import CTA from './components/CTA/CTA';
import Profile from './components/Profile/Profile';
import Footer from './components/Footer/Footer';

function App() {
  useEffect(() => {
    // スクロールアニメーション
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, observerOptions);

    const animateElements = document.querySelectorAll('.animate-on-scroll');
    animateElements.forEach(el => observer.observe(el));

    return () => {
      animateElements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="App">
      <Hero />
      <Problem />
      <Profile />
      <Solution />
      <Results />
      <Services />
      <WhyUs />
      <Flow />
      <FAQ />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
